import styled from '@emotion/styled'
import React from 'react'
import { colors } from '../../../../styles/variables'

export type InternalOnlyFilterValue = 'all' | 'internal' | 'network'

type Props = {
  value: InternalOnlyFilterValue
  onChange: (value: InternalOnlyFilterValue) => void
  hasActiveSubscription: boolean
}

const InternalOnlyFilter: React.FC<Props> = ({ value, onChange, hasActiveSubscription }) => {
  if (!hasActiveSubscription) {
    return null
  }

  return (
    <FilterContainer>
      <FilterLabel>Show:</FilterLabel>
      <FilterSelect value={value} onChange={e => onChange(e.target.value as InternalOnlyFilterValue)}>
        <option value="all">All Events</option>
        <option value="internal">Internal Only</option>
        <option value="network">Network Shared</option>
      </FilterSelect>
    </FilterContainer>
  )
}

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.grey};
`

const FilterSelect = styled.select`
  padding: 6px 12px;
  border: 1px solid ${colors.silver};
  border-radius: 6px;
  font-size: 14px;
  color: ${colors.grey};
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${colors.primaryColor};
  }
`

export default InternalOnlyFilter
